// extracted by mini-css-extract-plugin
export var closeButton = "_kh-1";
export var closeX = "_kh-3";
export var container = "_kh-0";
export var image = "_kh-2";